export const NAV_SHOW_TAB = "NAV_SHOW_TAB";
export const NAV_HIDE_TAB = "NAV_HIDE_TAB";
export const NAV_SET_ROUTE = "NAV_SET_ROUTE";
export const NAV_CHANGE_APP_STATE = "NAV_CHANGE_APP_STATE";
export const NAV_SEE_ACTION_AGAIN = "NAV_SEE_ACTION_AGAIN";

export const NAV_CHANGE_FIELD = "NAV_CHANGE_FIELD";
